import { render, staticRenderFns } from "./CoursesSwiper.vue?vue&type=template&id=16a1d0a2&scoped=true&"
import script from "./CoursesSwiper.vue?vue&type=script&lang=js&"
export * from "./CoursesSwiper.vue?vue&type=script&lang=js&"
import style0 from "./CoursesSwiper.vue?vue&type=style&index=0&id=16a1d0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1d0a2",
  null
  
)

export default component.exports